import { Injectable } from '@angular/core';
import {Company,  PagedResponseCompany} from '../models/Compnany'
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class CompanyService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getCompanies():Observable<PagedResponseCompany>{
    const data =  this.http.get<PagedResponseCompany>(this.APIURL+'/Company' + '?PageNumber=1&PageSize=50');
    this.messageService.add('Company Service: fetched companies');
    return data;
  }

  getCompany(id: number): Observable<Company> {
        const company =this.http.get<Company>(this.APIURL+'/Company/' + id);
    this.messageService.add(`Company Service: fetched company with id=${id}`);
    return company;
  }

//https://localhost:5001/api/Company?PageNumber=1&PageSize=2

// getKaizen(id: number): Observable<Kaizen> {
//   return this.http.get<any>(this.APIURL+'/Employee/' + id);
// }

//   addKaizen(val:any){
//     return this.http.post(this.APIURL+'/Employee',val);
//   }

//   updateKaizen(val:any){
//     return this.http.put(this.APIURL+'/Employee',val);
//   }

}